var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "onboarding-container clearfix login-container",
      class: { pageContainer: _vm.authToken }
    },
    [
      _vm.authToken
        ? _c(
            "router-link",
            {
              staticClass: "back-to-outfit gray-bottom-border",
              attrs: { to: "/account/account-settings" }
            },
            [
              _c("div", { staticClass: "wtw-container" }, [
                _c("span", { staticClass: "stay-black" }, [
                  _vm._v("Back to Account Settings")
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.authToken ? _c("logo") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "wtw-container small center" }, [
        _c(
          "form",
          { staticClass: "wtw-form" },
          [
            _c("h3", { staticClass: "text-center" }, [
              _vm._v("Reset Password")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-container" }, [
              !_vm.successMessage
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.password,
                        expression: "user.password"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      type: "password",
                      name: "password",
                      placeholder: "Password"
                    },
                    domProps: { value: _vm.user.password },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.user, "password", $event.target.value)
                        },
                        _vm.clearErrors
                      ]
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-container" }, [
              !_vm.successMessage
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordConfirm,
                        expression: "passwordConfirm"
                      }
                    ],
                    attrs: {
                      type: "password",
                      name: "passwordConfirm",
                      placeholder: "Confirm Password"
                    },
                    domProps: { value: _vm.passwordConfirm },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.passwordConfirm = $event.target.value
                        },
                        _vm.doPasswordsMatch
                      ]
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.passwordMatchError,
                      expression: "passwordMatchError"
                    }
                  ],
                  staticClass: "error-message"
                },
                [_vm._v(_vm._s(_vm.passwordMatchError))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errorMessage,
                      expression: "errorMessage"
                    }
                  ],
                  staticClass: "error-message"
                },
                [_vm._v(_vm._s(_vm.errorMessage))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.successMessage,
                      expression: "successMessage"
                    }
                  ],
                  staticClass: "wtw-panel"
                },
                [
                  _c("p", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.successMessage) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "stay-pink",
                          attrs: { to: "/account/login" }
                        },
                        [_vm._v("Click Here to Log In")]
                      )
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("transition-group", { attrs: { name: "fade" } }, [
              !_vm.dataSending && !_vm.successMessage
                ? _c(
                    "div",
                    {
                      key: "1",
                      staticClass: "button pink",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.resetPassword(_vm.user)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    Reset Password\n                "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dataSending
                ? _c(
                    "div",
                    { key: "2", staticClass: "loading-overlay" },
                    [_c("loader")],
                    1
                  )
                : _vm._e()
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "back-button",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.$router.go(-1)
            }
          }
        },
        [_vm._v("\n        Back\n    ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-012b76c0", { render: render, staticRenderFns: staticRenderFns })
  }
}